<template>
  <div class="part">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconPro.png" alt="">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>大众点评记录列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <div class="checkButton">
          <el-form-item label="平台院区">
            <el-select v-model="filters.areaCode" clearable placeholder="选择院区">
              <el-option v-for="(item,index) in actionsArea" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卡号">
            <el-input v-model="filters.cardNo" clearable></el-input>
          </el-form-item>
          <el-form-item label="订单编号">
            <el-input v-model="filters.orderNo" clearable></el-input>
          </el-form-item>
          <el-form-item label="核销状态">
            <el-select v-model="filters.witeOff" clearable="" placeholder="核销状态">
              <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker v-model="filters.startTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query(1)">查询</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="addData" @click="exportData">导出数据</div>
    </div>

    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" height="460" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="cardNo" label="卡号" width="100"></el-table-column>
        <el-table-column prop="customerName" label="姓名"></el-table-column>
        <el-table-column prop="platName" label="平台用户名"></el-table-column>
        <el-table-column prop="verificatioCode" label="券号"></el-table-column>
        <el-table-column prop="orderNo" label="订单编号"></el-table-column>
        <el-table-column prop="isSecondary" label="是否多次卡"></el-table-column>
        <el-table-column prop="onlineTotal" label="线上合计" width="90">
          <template slot="header">
            <el-tooltip class="item" effect="dark" content="(平台抵用券+平台立减+实付付款)" placement="top-start">
              <div>线上合计<i class="el-icon-warning"></i></div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="balancePayment" label="待付尾款">
          <template slot="header">
            <span class="resAndsug">待付尾款</span>
          </template>
        </el-table-column>
        <el-table-column prop="areaName" label="平台院区"></el-table-column>
        <el-table-column prop="dsepartmentName" label="科室"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="100"></el-table-column>
        <el-table-column prop="userName" label="创建人"></el-table-column>
        <el-table-column prop="witeOff" label="是否核销"></el-table-column>
        <el-table-column align="center" label="操作" width="110">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">详情
            </el-button>
            <el-button size="mini" type="primary" :disabled="scope.row.witeOff=='是'?true:false" @click="handAdd(scope.$index, scope.row)">核销</el-button>
            <!-- <el-button size="mini" type="danger">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
      <el-form :inline="true" :model="formData">
        <el-form-item label="卡号:" class="inputClass">
          <el-input v-model="formData.cardNo"></el-input>
        </el-form-item>
        <el-form-item label="订单图片" class="imgstyle">
          <div v-for="(item,index) in items" :key="index" class="imgIndex">
            <img :src="item" alt="" v-viewer="{zIndex:9999,fullscreen:false,toggleOnDblclick:false,toolbar:false,navbar:false,title:false,}">
          </div>
        </el-form-item>
        <el-form-item label="订单编号:">
          <el-input v-model="formData.orderNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="平台:">
          <el-input v-model="formData.bussinessChannel" disabled></el-input>
        </el-form-item>
        <el-form-item label="平台用户名:">
          <el-input v-model="formData.platName" disabled></el-input>
        </el-form-item>
        <el-form-item label="券号:">
          <el-input v-model="formData.verificatioCode" disabled></el-input>
        </el-form-item>
        <el-form-item label="是否多次卡:">
          <el-input v-model="formData.isSecondary" disabled></el-input>
        </el-form-item>
        <el-form-item label="商品总价:">
          <el-input v-model="formData.allPrice" disabled></el-input>
        </el-form-item>
        <el-form-item label="优惠信息:">
          <el-input v-model="formData.discount" disabled></el-input>
        </el-form-item>
        <el-form-item label="商家立减:">
          <el-input v-model="formData.businessReduce" disabled></el-input>
        </el-form-item>
        <el-form-item label="平台立减:">
          <el-input v-model="formData.platformReduce" disabled></el-input>
        </el-form-item>
        <el-form-item label="平台抵用券:">
          <el-input v-model="formData.voucher" disabled></el-input>
        </el-form-item>
        <el-form-item label="订单总价:">
          <el-input v-model="formData.orderPrice" disabled></el-input>
        </el-form-item>
        <el-form-item label="实际付款:">
          <el-input v-model="formData.actualPrice" disabled></el-input>
        </el-form-item>
        <el-form-item label="预付金:">
          <el-input v-model="formData.advancePayment" disabled></el-input>
        </el-form-item>
        <el-form-item label="线上合计:">
          <el-input v-model="formData.onlineTotal" disabled></el-input>
        </el-form-item>
        <el-form-item label="待付尾款:">
          <el-input v-model="formData.balancePayment" disabled></el-input>
        </el-form-item>
        <el-form-item label="平台院区:">
          <el-input v-model="formData.areaName" disabled></el-input>
        </el-form-item>
        <el-form-item label="科室:">
          <el-input v-model="formData.dsepartmentName" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "member",
  data() {
    return {
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
        cardNo: '',
        orderNo: '',
        witeOff: '',
        areaCode: ''
      },
      formData: {
        positionName: "",
      },
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      projectId: '',
      doctorOptions: [],
      instrumentOptions: [],
      positionOptions: [],
      items: [],
      actionsArea: [{
        name: "伯思立",
        id: 'bsl',
      }, {
        name: "百达丽",
        id: 'bdl',
      }, {
        name: "翡丽思",
        id: 'fls',
      },],
      options: [{
        label: '已核销',
        value: 1
      },
      {
        label: '未核销',
        value: 0
      }
      ]
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    handleEdit(index, row) {
      this.dialogFormVisible = true
      this.formData = JSON.parse(JSON.stringify(row))
      this.items = this.formData.scanPictureUrl.split(',')
      if (this.formData.bussinessChannel == '1') {
        this.formData.bussinessChannel = '大众点评'
      } else if (this.formData.bussinessChannel == '2') {
        this.formData.bussinessChannel = '新氧'
      }
    },
    handAdd(index, row) {
      console.log(row)
      this.$confirm("确定更改核销状态吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let querys = {
            id: row.id,
            witeOff: '1'
          }
          api.request('/scan/updateScanWiteOffRequest', querys, (res) => {
            if (res.result == true) {
              _g.toast("success", "状态修改成功")
              this.query(this.filters.pagination.page)
            } else {
              _g.toast("error", "状态修改失败")
              this.query(this.filters.pagination.page)
            }
          }, (err) => { })
        })
        .catch(() => { });
    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.startTime)
      var querys = {
        startTime: '',
        endTime: '',
        page: page,
        size: this.filters.pagination.limit,
        remark: this.filters.remark,
        bussinessChannel: '',
        areaCode: this.filters.areaCode,
        cardNo: this.filters.cardNo,
        orderNo: this.filters.orderNo,
        witeOff: this.filters.witeOff
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      // console.log(querys)
      api.requestQuiet('/scan/findScanPageList', querys, (res) => {
        // console.log(res)
        var data = res.data.list
        this.tableData = data
        this.orgData = data
        this.filters.pagination.total = parseInt(res.data.total)
      }, (err) => { })
    },

    // 导出数据
    exportData() {
      let exportUrl = axios.defaults.baseURL;
      var formData = new FormData();
      formData.append("page", this.filters.pagination.page)
      formData.append("size", this.filters.pagination.limit)
      formData.append("areaCode", this.filters.areaCode)
      formData.append("cardNo", this.filters.cardNo)
      formData.append("orderNo", this.filters.orderNo)
      formData.append("witeOff", this.filters.witeOff)
      if (this.filters.startTime) {
        formData.append("startTime", this.filters.startTime[0])
        formData.append("endTime", this.filters.startTime[1])
      }
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post(
              exportUrl + "scan/toExcelScanInfo", formData, {
                responseType: "blob",
              }
            )
            .then((res) => {
              console.log(res)
              const blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              });
              // console.log(blob, '----------0990');
              const fileName = "扫码数据.xlsx";
              const linkNode = document.createElement("a");
              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = "none";
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click(); //模拟在按钮上的一次鼠标单击
              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    }

  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page)
  },
  watch: {
    '$route'(to, from) {
      this.query(this.filters.pagination.page)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/main.css";

.sp1 {
  display: block;
}

.p1 {
  display: inline-block;
  color: #6e6e6e;
  font-size: 20px;
}

.p2 {
  display: inline-block;
  font-size: 20px;
  color: #000000;
  padding-left: 20px;
}

.part >>> .el-dialog--center .el-dialog__body {
  text-align: left;
}

.dialogItem >>> .el-input__inner {
  height: 34px;
  width: 240px;
  /* background: #e4e7ed; */
  background: #fff;
  border: none;
}

.inputClass >>> .el-input__inner {
  width: 411px;
  height: 34px;
  background: #ffffff;
  /* box-shadow: 0px 0px 5px 3px #CAEAFD; */
  border-radius: 3px;
  /* border: 1px solid #23A2EE; */
}

.dialogItem >>> .el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
  width: 96px;
}

.partFooter >>> .el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.checkButton >>> .el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter >>> .el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}

.iconClock {
  display: flex;
  align-items: center;
}

.iconClock img {
  height: 20px;
  margin-right: 5px;
}

.imgstyle {
  display: flex;
}

.imgIndex {
  float: left;
}

.imgIndex img {
  width: 100px;
  margin-right: 15px;
}

.part >>> .el-input.is-disabled .el-input__inner {
  color: #606266;
}

.el-table >>> .resAndsug {
  color: red !important;
}
</style>